module.exports = __webpack_public_path__ + "img/spartan-carpentry-millwork-cabinetry-07-xlarge.7b112cb6.jpg";